import { Navigate, Route, Routes } from 'react-router-dom';
import LoginView from '../../views/LoginView/LoginView';
import { LoginSettings, NotFound, PrivateComponent, PublicSite, WindowLoader } from 'medere-ui-framework';
import Dashboard from '../../views/Dashboard/Dashboard';
import { routeComponents } from '../types/Constants';
import React, { Suspense, useEffect, useState } from 'react';
import ProxyRpView from '../../views/Recipe/ProxyRpView';
import DigitalRPQRView from '../../views/Digitalrp/DigitalRPQRView';
import CancelAppointment from '../../views/CancelAppointment/CancelAppointment';
import ConfirmAppointment from '../../views/ConfirmAppointment/ConfirmAppointment';
import AddImagesToHC from '../../views/AddImagesToHC';
import StretcherBearerRequestView from '../../views/stretcherBearerRequestView';

function renderRouteComponent(Component: React.ComponentType<any>) {
    return <Component />;
}

export default function AppRouteComponents() {
    const notInMenuItemRoutes = routeComponents.filter(route => !route.ismenuitem);

    const [appConfig, setAppConfig] = useState<LoginSettings>(
        JSON.parse(localStorage.getItem('settings') ?? "{}")
    );

    const [home, setHome] = useState<string>('home');

    useEffect(() => {
        const handleStorageChange = () => {
            const newConfig = JSON.parse(localStorage.getItem('settings') ?? "{}");
            setAppConfig(newConfig);
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    useEffect(() => {
        setHome(appConfig?.loginResponse?.user?.profile?.homepage?.trim() || 'home');
    }, [appConfig?.loginResponse?.user?.profile?.homepage]);

    useEffect(() => {
        const stripEmptyHash = () => {
            if (window.location.hash === "#") {
                const cleanUrl = `${window.location.pathname}${window.location.search}`;
                window.history.replaceState(window.history.state, "", cleanUrl);
            }
        };

        stripEmptyHash();
        window.addEventListener("hashchange", stripEmptyHash);
        return () => window.removeEventListener("hashchange", stripEmptyHash);
    }, []);

    return (
        <Routes>
            {/* Rutas protegidas */}
            <Route element={<PrivateComponent />}>
                {notInMenuItemRoutes.map(({ route, component }) => (
                    <Route
                        key={route}
                        path={route}
                        element={
                            <Suspense fallback={<WindowLoader showLoader />}>
                                {renderRouteComponent(component as React.ComponentType<any>)}
                            </Suspense>
                        }
                    />
                ))}

                <Route path="/" element={<Navigate to={"/dashboard/"} />} />
                <Route path="/recetas" element={<ProxyRpView />} />
                <Route path="/dashboard/" element={<Navigate to={`/dashboard/${home}`} replace />} />
                <Route path="/dashboard/*" element={<Dashboard />} />
                <Route path="*" element={<Navigate to={`/dashboard/`} replace />} />
            </Route>

            {/* Ruta para login */}
            <Route path="/login" element={<LoginView />} />
            <Route path='/publicView/validateRP' element={<DigitalRPQRView/>} />
            <Route path='/publicView/cancelAppointment' element={<CancelAppointment/>} />
            <Route path='/publicView/addimagestohc' element={<AddImagesToHC/>} />
            <Route path='/publicView/confirmAppointment' element={<ConfirmAppointment/>} />
            <Route path='/publicView/stretcherbearerrequestview' element={<StretcherBearerRequestView/>} />
            <Route path="/" element={<Navigate to="/login" replace />} />

            {/* El resto no existe */}
            <Route path='*' element={<NotFound />} />
        </Routes>
    );
}
